// src/api.js
import axios from "axios";

// .env dosyasında: VITE_API_URL=https://api.example.com
const api = axios.create({
  // baseURL:  "http://192.168.2.153:7632/api/v1",
  baseURL: "https://myaccount.parts-soft.eu/api/v1",
  // baseURL: "http://localhost:3009/api/v1",

  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

const getOrCreateClientId = () => {
  let clientId = localStorage.getItem("clientId");
  if (!clientId) {
    clientId = `web_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem("clientId", clientId);
  }
  return clientId;
};


// IP geolocation ile şehir ve ülke bilgisi al
export const getLocationInfo = async () => {
  try {
    // Önce ipapi.co'yu dene
    const response = await axios.get('https://ipapi.co/json/', { timeout: 5000 });
    if (response.data && response.data.ip) {
      return {
        ip: response.data.ip,
        city: response.data.city,
        country: response.data.country_name,
        region: response.data.region,
        latitude: response.data.latitude,
        longitude: response.data.longitude
      };
    }
  } catch (error) {
    console.error('ipapi.co error:', error);
  }

  try {
    // Fallback olarak ipify.org'u dene
    const response = await axios.get('https://api.ipify.org?format=json', { timeout: 5000 });
    if (response.data && response.data.ip) {
      return {
        ip: response.data.ip,
        city: null,
        country: null,
        region: null,
        latitude: null,
        longitude: null
      };
    }
  } catch (error) {
    console.error('ipify.org error:', error);
  }

  // Hiçbiri çalışmazsa null dön
  return null;
};

// Cihaz bilgilerini al
export const getDeviceInfo = () => {
  try {
    const nav = navigator || {};
    const ua = nav.userAgent || "";
    const platform = nav.userAgentData?.platform || nav.platform || "";
    const deviceMemory = nav.deviceMemory ? `${nav.deviceMemory}GB` : "";
    const deviceName = `${platform}${deviceMemory ? ` ${deviceMemory}` : ''}`.trim() || null;

    // Daha detaylı cihaz bilgisi
    const screenInfo = `${window.screen.width}x${window.screen.height}`;
    const language = nav.language || "tr-TR";
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const connection = nav.connection ? nav.connection.effectiveType : "unknown";

    return {
      deviceName: deviceName || "web",
      platform: platform || "web",
      screen: screenInfo,
      language: language,
      timezone: timezone,
      connection: connection,
      userAgent: ua
    };
  } catch (error) {
    console.error('Device info error:', error);
    return null;
  }
};

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    // localStorage'dan token al (veya başka bir store)
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Her isteğe clientId ekle
    const clientId = getOrCreateClientId();
    config.headers["x-client-id"] = clientId;

    // Login endpoint'i için cihaz bilgilerini header'a ekle
    if (config.url === '/auth/login') {
      try {
        const nav = navigator || {};
        const ua = nav.userAgent || "";
        const platform = nav.userAgentData?.platform || nav.platform || "";
        const deviceMemory = nav.deviceMemory ? `${nav.deviceMemory}GB` : "";
        const deviceName = `${platform}${deviceMemory ? ` ${deviceMemory}` : ''}`.trim() || null;

        const screenInfo = `${window.screen.width}x${window.screen.height}`;
        const language = nav.language || "tr-TR";
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const connection = nav.connection ? nav.connection.effectiveType : "unknown";

        config.headers["x-device-name"] = deviceName || "web";
        config.headers["x-device-platform"] = platform || "web";
        config.headers["x-device-screen"] = screenInfo;
        config.headers["x-device-language"] = language;
        config.headers["x-device-timezone"] = timezone;
        config.headers["x-device-connection"] = connection;
        config.headers["user-agent"] = ua;
      } catch (error) {
        console.error('Device info header error:', error);
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
api.interceptors.response.use(
  (response) => response.data, // sadece response.data dön
  (error) => {
    // Token expired vb. durumları kontrol et
    // if (error.response?.status === 401) {
    //   // örn. logout akışı
    //   console.warn("Oturum süresi doldu.");
    //   localStorage.removeItem("token");
    //   window.location.href = "/login";
    // }

    // Hata mesajı dön
    return Promise.reject(error);
  }
);

export default api;
